// extracted by mini-css-extract-plugin
export default {"todoForm":"TodoForm_todoForm__fwU6U","formInput":"TodoForm_formInput__AAaDe"};